import { Link } from "react-router-dom";
import MovieCard from "@/components/base/MovieCard";
import { getMoviesByCategory } from "@/mocks/movies";

export default function AnimeSection() {
  const animes = getMoviesByCategory("dongman").slice(0, 6);

  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5 md:mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              人气动漫
            </h2>
            <p className="text-sm text-foreground-500 mt-1">热血与治愈，二次元的世界等你探索</p>
          </div>
          <Link
            to="/category/dongman"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            全部动漫 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {animes.map((movie) => (
            <MovieCard
              key={movie.id}
              id={movie.id}
              title={movie.title}
              image={movie.image}
              rating={movie.rating}
              category={movie.category}
              year={movie.year}
              isNew={movie.isNew}
            />
          ))}
        </div>
      </div>
    </section>
  );
}